import React from 'react';
import { Router, Route, IndexRoute, Redirect, IndexRedirect, browserHistory } from 'react-router';
import api from 'api';
import Layout from './layout/Layout';
import Login from './modules/authentication/containers/Login';
import AdminLogin from './admin/authentication/Login';
/* INIT WIZARD */
import Wizard from './init-wizard/Wizard';
/* DASHBOARD */
import Overview from './modules/dashboard/Overview';
/* INVENTORY */
import * as property from './modules/inventory/property/containers';
import * as propertyGroup from './modules/inventory/propertyGroup/containers';
import * as owner from './modules/inventory/owner/containers';
//import * as locality from './modules/inventory/locality/containers';
import * as amenity from './modules/inventory/amenity/containers';
import * as zone from './modules/inventory/zone/containers';
import * as area from './modules/inventory/area/containers';
import * as channel from './modules/inventory/channel/containers';
import * as synchronisation from './modules/inventory/synchronisation/containers';
/* DAILY RENTAL */
import * as rentalRuleset from './modules/daily-rental/rental-ruleset/containers';
import * as inquiry from './modules/daily-rental/inquiry/containers';
import * as reservation from './modules/daily-rental/reservation/containers';
import * as customer from './modules/daily-rental/customer/containers';
import * as arrivalsDepartures from './modules/daily-rental/arrivals-departures/containers';
import * as availabilities from './modules/daily-rental/availabilities/containers';
import * as checkInOutRuleset from './modules/daily-rental/check-in-out-ruleset/containers';
import * as cancellationPolicy from './modules/daily-rental/cancellation-policy/containers';
/* CONTENT */
import * as propertyReview from './modules/content/property-review/containers';
import * as propertyContent from './modules/content/property-content/containers';
import * as areaContent from './modules/content/area-content/containers';
import * as listingContent from './modules/content/listing-content/containers';
/* EMAIL */
import * as emailMessage from './modules/email/message/containers';
import * as emailTemplate from './modules/email/template/containers';
import * as emailPropertyData from './modules/email/property-data/containers';
import * as automaticSending from './modules/email/automatic-sending/containers';
/* SETTINGS */
import * as globalSettings from './modules/settings/global/containers';
import * as userSettings from './modules/settings/user/containers';
/* USERS */
import * as user from './modules/users/containers';
/* HELP */
import * as help from './modules/help/containers';

/* ADMIN */
import * as adminCustomer from './admin/customer/containers';

import { PMS_URL, FRONTEND_ADMIN_URL } from '../config';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.onEnterRoute = this.onEnterRoute.bind(this);
    this.canAccessUsers = this.canAccessUsers.bind(this);
    this.canAccessManagement = this.canAccessManagement.bind(this);
    this.canAccessCalendar = this.canAccessCalendar.bind(this);
    this.onChangeRoute = this.onChangeRoute.bind(this);
    this.checkIfAlreadyAuth = this.checkIfAlreadyAuth.bind(this);
    this.onEnterAdminRoute = this.onEnterAdminRoute.bind(this);
  }
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const root = PMS_URL === '/' ? '' : PMS_URL;
    const defaultURL = '/dashboard/overview';
    return (
      <Router history={ browserHistory }>
        <Redirect from="/" to={ root + defaultURL } />
        <Redirect from={ PMS_URL } to={ root + root + defaultURL } />
        <Route path="/init-wizard" component={Layout}  onEnter={this.onEnterRoute}>
          <IndexRoute component={ Wizard } />
        </Route>
        { this.dashboardRoutes() }
        { this.managementRoutes() }
        { this.inventoryRoutes() }
        { this.websiteRoutes() }
        { this.settingsRoutes() }
        { this.helpRoutes() }
        <Route path="/maintenance" component={ Layout } onEnter={this.onEnterRoute} onChange={this.onChangeRoute}>
          <IndexRedirect to="emails" />
          <Route path="emails" component={ emailMessage.Maintenance } />
        </Route>
        <Route path={ FRONTEND_ADMIN_URL } component={ Layout } onEnter={this.onEnterAdminRoute} onChange={this.onChangeRoute}>
          <IndexRedirect to="customers" />
          <Route path="customers">
            <IndexRoute component={ adminCustomer.Listing } />
            <Route path="new" component={ adminCustomer.Form } />
            <Route path=":id" component={ adminCustomer.Form } />
          </Route>
        </Route>
        <Route path={ FRONTEND_ADMIN_URL + '/login' } component={AdminLogin} onEnter={this.checkIfAlreadyAuth} />
        <Route path={ root + '/login' } component={Login} onEnter={this.checkIfAlreadyAuth} />
      </Router>
    );
  }

  dashboardRoutes() {
    return (
      <Route path="/dashboard" component={ Layout } onEnter={this.onEnterRoute} onChange={this.onChangeRoute}>
        <IndexRedirect to="overview" />
        <Route path="overview" component={ Overview } />
        <Route path="daily-rental">
          <IndexRedirect to="inquiries" />
          <Route path="inquiries" onEnter={ this.canAccessManagement }>
            <IndexRoute component={ inquiry.Listing } />
            <Route path="new" component={ inquiry.Form } />
            <Route path=":id" component={ inquiry.Show } />
            <Route path=":id/edit" component={ inquiry.Form } />
          </Route>
          <Route path="reservations" onEnter={ this.canAccessManagement }>
            <IndexRoute component={ reservation.Listing } />
            <Route path="new" component={ reservation.Form } />
            <Route path=":id" component={ reservation.Show } />
            <Route path=":id/edit" component={ reservation.Form } />
          </Route>
          <Route path="availabilities" onEnter={ this.canAccessCalendar}>
            <IndexRedirect to="calendar" />
            <Route path="calendar" component={ availabilities.Calendar } />
            <Route path="search" component={ availabilities.Listing } onEnter={ this.canAccessManagement } />
          </Route>
          <Route path="arrivals-departures" onEnter={ this.canAccessManagement }>
            <IndexRoute component={ arrivalsDepartures.Listing } />
          </Route>
          <Route path="ibe-calendar" component={ property.IbeCalendar } />
        </Route>
        <Route path="email" onEnter={ this.canAccessManagement }>
          <IndexRedirect to="messages" />
          <Route path="messages">
            <IndexRoute component={ emailMessage.Listing } />
            <Route path="new" component={ emailMessage.CreateForm } />
            <Route path=":id" component={ emailMessage.Show } />
            <Route path=":id/edit" component={ emailMessage.CreateForm } />
            <Route path=":id/reply" component={ emailMessage.ReplyForm } />
          </Route>
        </Route>
      </Route>
    );
  }

  managementRoutes() {
    return (
      <Route path="/management" component={ Layout } onEnter={this.onEnterRoute} onChange={this.onChangeRoute}>
        <IndexRedirect to="daily-rental/customers" />
        <Route path="daily-rental">
          <IndexRedirect to="customers" />
          <Route path="customers" onEnter={ this.canAccessManagement }>
            <IndexRoute component={ customer.Listing } />
            <Route path="new" component={ customer.Form } />
            <Route path=":id" component={ customer.Form } />
          </Route>
          <Route path="inquiries" onEnter={ this.canAccessManagement }>
            <IndexRoute component={ inquiry.Listing } />
            <Route path="new" component={ inquiry.Form } />
            <Route path=":id" component={ inquiry.Show } />
            <Route path=":id/edit" component={ inquiry.Form } />
          </Route>
          <Route path="reservations" onEnter={ this.canAccessManagement }>
            <IndexRoute component={ reservation.Listing } />
            <Route path="new" component={ reservation.Form } />
            <Route path=":id" component={ reservation.Show } />
            <Route path=":id/edit" component={ reservation.Form } />
          </Route>
          <Route path="availabilities">
            <IndexRedirect to="calendar" />
            <Route path="calendar" component={ availabilities.Calendar } />
            <Route path="search" component={ availabilities.Listing } onEnter={ this.canAccessManagement } />
          </Route>
        </Route>
        <Route path="email" onEnter={ this.canAccessManagement }>
          <IndexRedirect to="messages" />
          <Route path="messages">
            <IndexRoute component={ emailMessage.Listing } />
            <Route path="new" component={ emailMessage.CreateForm } />
            <Route path=":id" component={ emailMessage.Show } />
            <Route path=":id/edit" component={ emailMessage.CreateForm } />
            <Route path=":id/reply" component={ emailMessage.ReplyForm } />
          </Route>
          <Route path="templates">
            <IndexRoute component={ emailTemplate.Listing } />
            <Route path="new" component={ emailTemplate.Form } />
            <Route path=":id" component={ emailTemplate.Form } />
          </Route>
          <Route path="automatic-sendings">
            <IndexRoute component={ automaticSending.Listing } />
            <Route path="new" component={ automaticSending.Form } />
            <Route path=":id" component={ automaticSending.Form } />
          </Route>
        </Route>
      </Route>
    );
  }

  inventoryRoutes() {
    return (
      <Route path="/inventory" component={ Layout } onEnter={this.onEnterRoute} onChange={this.onChangeRoute}>
        <IndexRedirect to="properties" />
        <Route path="properties">
          <IndexRoute component={ property.Listing } />
          <Route path="ibe-calendar" component={ property.IbeCalendar } />
          <Route path="new" component={ property.CreateForm } />
          <Route path=":id" component={ property.EditForm } />
        </Route>
        <Route path="propertyGroups">
          <IndexRoute component={ propertyGroup.Listing } />
          <Route path="new" component={ propertyGroup.Form } />
          <Route path=":id" component={ propertyGroup.Form } />
        </Route>
        <Route path="owners">
          <IndexRoute component={ owner.Listing } />
          <Route path="new" component={ owner.Form } />
          <Route path=":id" component={ owner.Form } />
        </Route>
        <Route path="amenities">
          <IndexRoute component={ amenity.Listing } />
          <Route path="new" component={ amenity.Form } />
          <Route path=":id" component={ amenity.Form } />
        </Route>
        <Route path="zones">
          <IndexRoute component={ zone.Listing } />
          <Route path="new" component={ zone.Form } />
          <Route path=":id" component={ zone.Form } />
        </Route>
        <Route path="areas">
          <IndexRoute component={ area.Listing } />
          <Route path="new" component={ area.Form } />
          <Route path=":id" component={ area.Form } />
        </Route>
        <Route path="channels">
          <IndexRoute component={ channel.Listing } />
          <Route path="new" component={ channel.CreateForm } />
          <Route path=":id" component={ channel.EditForm } />
        </Route>
        <Route path="synchronisations">
          <IndexRoute component={ synchronisation.Listing } />
          <Route path="new" component={ synchronisation.CreateForm } />
          <Route path=":id" component={ synchronisation.EditForm } />
        </Route>
        <Route path="daily-rental">
          <IndexRedirect to="check-in-out-ruleset" />
          <Route path="check-in-out-rulesets" onEnter={ this.canAccessManagement }>
            <IndexRoute component={ checkInOutRuleset.Listing } />
            <Route path="new" component={ checkInOutRuleset.Form } />
            <Route path=":id" component={ checkInOutRuleset.Form } />
          </Route>
          <Route path="cancellation-policies" onEnter={ this.canAccessManagement }>
            <IndexRoute component={ cancellationPolicy.Listing } />
            <Route path="new" component={ cancellationPolicy.Form } />
            <Route path=":id" component={ cancellationPolicy.Form } />
          </Route>
        </Route>
      </Route>
    );
  }

  websiteRoutes() {
    return (
      <Route path="/website" component={ Layout } onEnter={this.onEnterRoute} onChange={this.onChangeRoute}>
        <IndexRedirect to="content/property-reviews" />
        <Route path="content" onEnter={ this.canAccessManagement }>
          <IndexRedirect to="property-reviews" />
          <Route path="property-reviews">
            <IndexRoute component={ propertyReview.Listing } />
            <Route path="new" component={ propertyReview.Form } />
            <Route path=":id" component={ propertyReview.Form } />
          </Route>
          <Route path="areas">
            <IndexRoute component={ areaContent.Listing } />
            <Route path="new" component={ areaContent.Form } />
            <Route path=":id" component={ areaContent.Form } />
          </Route>
          <Route path="listings">
            <IndexRoute component={ listingContent.Listing } />
            <Route path="new" component={ listingContent.Form } />
            <Route path=":id" component={ listingContent.Form } />
          </Route>
        </Route>
      </Route>
    );
  }

  settingsRoutes() {
    return (
      <Route path="/settings" component={ Layout } onEnter={this.onEnterRoute} onChange={this.onChangeRoute}>
        <IndexRedirect to="global-settings" />
        <Route path="global-settings" component={ globalSettings.Listing } onEnter={ this.canAccessManagement } />
        <Route path="user-settings" component={ userSettings.Listing } onEnter={ this.canAccessManagement } />
        <Route path="users" onEnter={ this.canAccessUsers }>
          <IndexRoute component={ user.Listing } />
          <Route path="new" component={ user.Form } />
          <Route path=":id" component={ user.Form } />
        </Route>
      </Route>
    );
  }

  helpRoutes() {
    return (
      <Route path="/help" component={ Layout } onEnter={this.onEnterRoute} onChange={this.onChangeRoute}>
        <IndexRedirect to="about" />
        <Route path="about" component={ help.About } />
      </Route>
    );
  }

  getCurrentUser() {
    const currentUser = localStorage.getItem('currentUser');
    return currentUser ? JSON.parse(currentUser) : null;
  }

  onEnterRoute(nextState, replace) {
    const root = PMS_URL === '/' ? '' : PMS_URL;
    const urlRequested = nextState.location.pathname;
    const url = window.location.hostname.includes('www.') ? window.location.hostname.split('www.')[1] : window.location.hostname;
    const domain_name = url.split('.')[0];
    const currentUser = this.getCurrentUser();
    // const isAuth = currentUser && currentUser.domain_name === domain_name && !currentUser._is_pms_admin;
    const isAuth = currentUser && !currentUser._is_pms_admin;
    // Require auth
    if (!isAuth && urlRequested !== `${root}/login`) {
      this.props.api.auth.rememberLocationRequested(urlRequested);
      replace({
        pathname: `${root}/login`,
        state: null,
      });
    } else {
      this.props.api.routing.setRoot(nextState.location);
    }
  }
  onChangeRoute(prevState, nextState, replace) {
    if (prevState.location.pathname !== nextState.location.pathname) {
      if (!nextState.location.pathname.match(`^${FRONTEND_ADMIN_URL}`)) {
        this.onEnterRoute(nextState, replace);
      } else {
        this.onEnterAdminRoute(nextState, replace);
      }
    }
  }
  checkIfAlreadyAuth(nextState, replace) {
    const url = window.location.hostname.includes('www.') ? window.location.hostname.split('www.')[1] : window.location.hostname;
    const domain_name = url.split('.')[0];
    const currentUser = this.getCurrentUser();
    if (currentUser) {
      if (currentUser._is_pms_admin) {
        replace({
          pathname: FRONTEND_ADMIN_URL,
          state: null,
        });
      // } else if (currentUser.domain_name === domain_name) {
      } else {
        if (!nextState.params.client_id || nextState.params.client_id === currentUser.client_id) {
          replace({
            pathname: '/',
            state: null,
          });
        }
      }
    }
  }
  canAccessUsers(nextState, replace) {
    const currentUser = this.getCurrentUser();
    if (!currentUser.group || currentUser.group.name !== 'admin') {
      return replace({
        pathname: '/',
        state: null,
      });
    }
  }
  canAccessManagement(nextState, replace) {
    const currentUser = this.getCurrentUser();
    if (!currentUser.group || !['admin', 'manager'].includes(currentUser.group.name)) {
      return replace({
        pathname: '/',
        state: null,
      });
    }
  }
  canAccessCalendar(nextState, replace) {
    const currentUser = this.getCurrentUser();
    if (!currentUser.group || !['admin', 'manager', 'owner'].includes(currentUser.group.name)) {
      return replace({
        pathname: '/',
        state: null,
      });
    }
  }

  onEnterAdminRoute(nextState, replace) {
    const currentUser = this.getCurrentUser();
    const urlRequested = nextState.location.pathname;
    const isAuth = currentUser && currentUser._is_pms_admin;
    // Require auth
    if (!isAuth && urlRequested !== `${FRONTEND_ADMIN_URL}/login`) {
      this.props.api.auth.rememberLocationRequested(urlRequested);
      replace({
        pathname: `${FRONTEND_ADMIN_URL}/login`,
        state: null,
      });
    } else {
      this.props.api.routing.setRoot(nextState.location);
    }
  }
}

App.propTypes = {
  api: React.PropTypes.object,
};

export default api.connect(App);



// WEBPACK FOOTER //
// ./src/frontend/App.jsx